import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DeviceIdentificationService {
  // private width = new BehaviorSubject(1250);
  // private isSmallDevice = new BehaviorSubject(false);

  private width = new Subject<number>();
  private isSmallDevice = new Subject<boolean>();
  constructor() {

  }
  setWidth(width: number) {
    this.setIsSmallDevice(width);
    this.width.next(width);
  }
  getWidth(): Observable<any> {

    return this.width.asObservable();
  }
  private setIsSmallDevice(providedWidth: number) {
    if (providedWidth < 812) {
      this.isSmallDevice.next(true);
    }
    else {
      this.isSmallDevice.next(false);
    }

  }
  getIsSmallDevice(): Observable<any> {
    return this.isSmallDevice.asObservable();
  }
}
